import { render, staticRenderFns } from "./feedbackOptOutField.vue?vue&type=template&id=a2b6b9b6"
import script from "./feedbackOptOutField.vue?vue&type=script&lang=ts"
export * from "./feedbackOptOutField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports